<template>
    <div class="userinfo clearfix">
        <div class="current">
            <p>当前位置：首页>再认证</p>
        </div>
        <div class="content"> 
            <div class="title">
                <h1>再认证信息确认   <span> / Recognition of re-authentication information</span></h1>
            </div>
            <div class="warp">
                <div class="top">
					<el-form v-if="isImport==2" :model="infodata" :rules="infodataRules" ref="enrollInfo" @submit.native.prevent>
						<el-form-item prop="headImg" class="photo" label-width="0">
						    <upload-images
						        v-model="infodata.headImg"
						        :limit="1"
						        string>
						        <div class="mask">
						            <i class="el-icon-circle-plus-outline"></i>
						            点击上传照片
						        </div>
						    </upload-images>
						</el-form-item>
						<el-form-item label="姓名:" prop="name" >
						    <el-input v-model="infodata.name" placeholder="请输入真实姓名"></el-input>
						</el-form-item>
						<el-form-item label="性别:" prop="sex">
						    <el-radio-group v-model="infodata.sex">
						        <el-radio :label="1">男</el-radio>
						        <el-radio :label="2">女</el-radio>
						    </el-radio-group>
						</el-form-item>
						<el-form-item label="证件类型:" prop="certificateType">
						    <el-select clearable v-model="infodata.certificateType" placeholder="请选择证件类型">
						        <el-option
						            v-for="item in typeLists"
						            :key="item.value"
						            :label="item.name"
						            :value="item.value">
						        </el-option>
						    </el-select>
						</el-form-item>
						<el-form-item label="证件号码:" prop="certificateNumber">
						    <el-input v-model="infodata.certificateNumber" placeholder="请输入证件号码"></el-input>
						</el-form-item>
						<el-form-item label="私人邮箱:" prop="email">
						    <el-input v-model="infodata.email" placeholder="请输入邮箱"></el-input>
						</el-form-item>
						<el-form-item label="" prop="name" >
						    <p>获证级别：{{infodata.examType | testfilters}}</p>
						</el-form-item>
						<el-form-item label="所在城市:" prop="address">
						    <el-input v-model="infodata.address" placeholder="请输入详细地址"></el-input>
						    <!-- {{ enrollInfo.provinceId }} - {{ enrollInfo.cityId }} - {{ enrollInfo.ffff }} -->
						</el-form-item>
					</el-form>
					<template v-else>
						<div class="left">
						    <p><span>姓名：{{infodata.name}}</span><span>性别：{{infodata.sex==1?"男":"女"}}</span></p>
						    <p>证件类型：{{typeList[infodata.certificateType]}}</p>
						    <p>证件号码：{{infodata.certificateNumber}}</p>
						    <p>私人邮箱：{{infodata.email}}</p>
						    <p>获证级别：{{infodata.examType | testfilters}}</p>
						    <p v-if="infodata.province">地址：{{infodata.province+infodata.city+infodata.address}}</p>
							<p v-else>地址：{{infodata.address}}</p>
						</div>
						<div class="right">
						    <img :src="infodata.headImg" alt="">
						</div>
					</template>
                </div>
                <el-form :model="enrollInfo" :rules="InfoRules" ref="enrollInfo" label-width="310px" label-position="left" @submit.native.prevent>
                    <el-form-item :label="infodata.recertStatus==3||infodata.recertStatus==4?'电话号码：'+infodata.phone:'电话号码：'"  prop="phone">
                        <el-input v-if="infodata.recertStatus==1||infodata.recertStatus==2" v-model="enrollInfo.phone" placeholder="请输入电话"></el-input>
                    </el-form-item>
					</el-form-item>
                    <el-form-item :label="infodata.recertStatus==3||infodata.recertStatus==4?'现工作单位名称：'+condata.companyName:'现工作单位名称：'"  prop="companyName">
                        <el-input v-if="infodata.recertStatus==1||infodata.recertStatus==2" v-model="enrollInfo.companyName" placeholder="请输入工作单位"></el-input>
                    </el-form-item>
                    <el-form-item :label="infodata.recertStatus==3||infodata.recertStatus==4?'工作单位所在行业：'+condata.companyIndustry:'工作单位所在行业：'"  prop="companyIndustry">
                        <el-select v-if="infodata.recertStatus==1||infodata.recertStatus==2" clearable v-model="enrollInfo.companyIndustry" placeholder="请选择工作单位所在行业">
                            <el-option
                                v-for="item in companyIndustryList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="infodata.recertStatus==3||infodata.recertStatus==4?'工作单位规模：'+condata.companyScale:'工作单位规模：'" prop="companyScale" >
                        <el-select v-if="infodata.recertStatus==1||infodata.recertStatus==2" clearable v-model="enrollInfo.companyScale" placeholder="请选择工作单位规模">
                            <el-option
                                v-for="item in companyScaleList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="infodata.recertStatus==3||infodata.recertStatus==4?'工作单位类型：'+condata.companyType:'工作单位类型：'" prop="companyType" >
                        <el-select v-if="infodata.recertStatus==1||infodata.recertStatus==2" clearable v-model="enrollInfo.companyType" placeholder="请选择工作单位类型">
                            <el-option
                                v-for="item in companyTypeList"
                                :key="item.value"
                                :label="item.name"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="infodata.recertStatus==3||infodata.recertStatus==4?'任职部门：'+condata.department:'任职部门：'" prop="department">
                        <el-input v-if="infodata.recertStatus==1||infodata.recertStatus==2" v-model="enrollInfo.department" placeholder="请输入任职部门"></el-input>
                    </el-form-item>
                    <el-form-item :label="infodata.recertStatus==3||infodata.recertStatus==4?'职位：'+condata.position:'职位：'" prop="position">
                        <el-select v-if="infodata.recertStatus==1||infodata.recertStatus==2" clearable v-model="enrollInfo.position" placeholder="请选择工作单位类型">
                            <el-option
                                v-for="item in positionList"
                                :key="item.value"
                                :label="item.name"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <div class="buttons">
                    <el-button @click="submit()" >已更改并保存</el-button>
                    <el-button @click="next()">下一步</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { enrollInfoDetailAll,orderAdd,certDetail } from '@/api/center'
import { listByType } from '@/api/cms'
import uploadImages from '@/components/imageUpLoad'
import { enrollInfoUpdate,enrollCompanyUpdateone } from '@/api/enroll'

export default {
    name: 'InformationValidation',
	components: {
	    uploadImages
	},
    data(){
        let phoneRules = (rule, value, callback) => {
		    if(this.enrollInfo.phone ==''||this.enrollInfo.phone == null){
		        return callback()
		    }else{
                console.log(this.enrollInfo.phone)
		        return callback(new Error('请输入正确的手机号'))
		    }
		}
        return {
            checked: false,
            Info:{
                phone:'13986758478',
            },
			typeList: ['其他','','身份证','港澳居民身份证','台湾居民来大陆通行证','外籍人士护照'],
			infodata:{
				headImg:'',
				name:'',
				sex:'',
				certificateType:'',
				certificateNumber:'',
				email:'',
				address:'',
				id:this.$route.query.ids
			},
			typeLists: [],
			condata:{},
			infodataRules:{},
			companyIndustryList: [
			    { label: '银行', value: '1' },
			    { label: '证券', value: '2' },
			    { label: '保险', value: '3' },
			    { label: '多元/互联网金融', value: '4' },
			    { label: '商贸', value: '5' },
			    { label: '会计审计', value: '6' },
			    { label: '核工业', value: '7' },
			    { label: '兵器兵装', value: '8' },
			    { label: '航天', value: '9' },
			    { label: '航空工业', value: '10' },
			    { label: '律师/法律', value: '11' },
			    { label: '机械制造', value: '12' },
			    { label: '建筑/建材', value: '13' },
			    { label: '房地产', value: '14' },
			    { label: '有色冶金', value: '15' },
			    { label: '纺织工业', value: '16' },
			    { label: '电子工业', value: '17' },
			    { label: '信息/通信', value: '18' },
			    { label: '批发/零食/租赁', value: '19' },
			    { label: '农/林/牧/渔,', value: '20' },
			    { label: '水利/电力', value: '21' },
			    { label: '交通/物流/仓储', value: '22' },
			    { label: '文化传媒', value: '23' },
			    { label: '教育科研', value: '24' },
			    { label: '咨询顾问', value: '25' },
			    { label: '食品', value: '26' },
			    { label: '旅游/餐饮/服务业', value: '27' },
			    { label: '医疗医药', value: '28' },
			    { label: '公共组织', value: '29' },
			    { label: '能源/石化/矿产', value: '30' },
			    { label: '其他', value: '-1' }
			],
			companyScaleList: [
			    { label: '100人以下', value: '1' },
			    { label: '100-999人', value: '2' },
			    { label: '1000-9999人', value: '3' },
			    { label: '10000人以上', value: '4' },
			],
			companyTypeList: [],
			positionList: [],
            enrollInfo: {
                phone:'',
			    companyName: '',
				companyIndustry: '',
				companyScale:'',
				companyType:'',
			    department:'',
			    position:'',
            },
           InfoRules:{
               phone:[
					{ required: true, message: '请输入手机号', trigger: 'blur' },
				]
           },
		   isImport:null
        }
    },
    mounted(){
		listByType("IDENTIFY").then(res => {
			this.typeLists = res
		})
		listByType("work_title").then(res => {
			this.positionList = res
		})
		listByType("enterprise_type").then(res => {
			this.companyTypeList = res
		})
		certDetail({id:this.$route.query.id}).then(res => {
			this.isImport=res.cert.isImport
		})
		enrollInfoDetailAll({id:this.$route.query.ids}).then(res=>{
			res.enrollInfo.certificateType = parseInt(res.enrollInfo.certificateType)+1
			this.infodata = res.enrollInfo
			if(!this.infodata.headImg){
				this.infodata.headImg = ''
			}
			this.infodata.certificateType = this.infodata.certificateType+''
			if(this.infodata.recertStatus==0){
				this.$message({
				    message: '再认证状态出错',
				    type: 'warning'
				});
			}
			this.enrollInfo.phone = res.enrollInfo.phone
			res.enrollCompanys.forEach((val,index)=>{
				if(val.status==0){
					val.phone = res.enrollInfo.phone
					this.enrollInfo = {...val}
					this.companyIndustryList.forEach((vals,index)=>{
						if(vals.value==val.companyIndustry){
							val.companyIndustry = vals.label
						}
					})
					this.companyScaleList.forEach((vals,index)=>{
						if(vals.value==val.companyScale){
							val.companyScale = vals.label
						}
					})
					this.companyTypeList.forEach((vals,index)=>{
						if(vals.value==val.companyType){
							val.companyType = vals.label
						}
					})
					this.positionList.forEach((vals,index)=>{
						if(vals.value==val.position){
							val.position = vals.label
						}
					})
					this.condata = val
				}
			})
		})
    },
    methods:{
        submit(){
			if(this.isImport!=2){
				enrollInfoUpdate({id:this.$route.query.ids,phone:this.enrollInfo.phone},false).then(res => {
					enrollCompanyUpdateone(this.enrollInfo,false).then(res => {
						// orderAdd({tbInfoUserId:this.$route.query.ids,certId:this.$route.query.id}).then(res => {
						// 	console.log(res)
						// })
					})
				})
			}else{
				enrollInfoUpdate(this.infodata,false).then(res => {
					enrollCompanyUpdateone(this.enrollInfo,false).then(res => {
						// orderAdd({tbInfoUserId:this.$route.query.ids,certId:this.$route.query.id}).then(res => {
						// 	console.log(res)
						// })
					})
				})
			}
		},
		next(){
			enrollInfoUpdate({id:this.$route.query.ids,phone:this.enrollInfo.phone},false).then(res => {
				if(this.infodata.peopleType==1&&this.infodata.examType){
					this.$router.push({
					    path: '/center/reCertification',
					    query: {
					        id:this.$route.query.id,
							ids:this.$route.query.ids
					    }
					})
				}else{
					enrollCompanyUpdateone(this.enrollInfo,false).then(res => {
						this.$router.push({
						    path: '/center/reCertification',
						    query: {
						        id:this.$route.query.id,
								ids:this.$route.query.ids
						    }
						})
					})
				}
			})
		}
    }
}
</script>

<style scoped>
	.content  .buttons{margin-top: 43px;margin-bottom: 10px;}
	.userinfo .content  .getcode >>> button {margin-left: 20px;}
	.hong >>> .el-form-item__label{color: red;}
    .warp {
        display: block;
        width: 560px;
        margin: 0 auto;
        padding-top: 15px;
    }
    .top{
        width: 100%;
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
    }
	.top >>> .el-form-item__content{
		width: 400px;
	}
    .left p:nth-of-type(1){
        display: flex;
    }
    .left p:nth-of-type(1) span {
        margin-right: 30px;
    }
    .left p {
        font-size: 14px;
        line-height: 32px;
    }
    .right {
        padding-top: 8px;
		width: 140px;
		height: 180px;
		overflow: hidden;
    }
	.right img{
		width: 100%;
		height: 100%;
	}
    .buttons{
        text-align: center;
    }
	.upload >>> .el-icon-circle-plus-outline{display: block!important;margin-top: 10px;}
	.photo .upload >>> .el-upload--picture-card{height: 207px;}
	.photo .upload >>> .mask i{padding-top: 74px;}
	.photo .upload >>> .el-upload-list__item{height: 207px;}
</style>
